/**
 * A dictionary containing error messages to show in TelephoneTextbox and TelephoneTextbox.Field
 */
export const errorMessages: Record<string, string> = {
  "Country invalid": "Please enter a valid phone number for the selected country",
  "International invalid": "Please enter a valid international phone number",
  required: "Telephone is required",
  "invalid format": "Please enter a valid phone number",
  "invalid paste": "Pasted content must contain a valid phone number",
  "too long": "Phone number is too long",
  "too short": "Phone number is too short",
  "invalid country": "Invalid country code",
  "military format": "Military phone numbers require special formatting",
};
